exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text[_v-34cd3954]{height:160px;border-top:1px solid #ddd}.text textarea[_v-34cd3954]{padding:10px;height:100%;width:100%;border:none;outline:none;font-family:Micrsofot Yahei;resize:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-34cd3954&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/text.vue
 ** module id = 319
 ** module chunks = 0
 **/